import { useState, useEffect, useRef } from "react";
import {
	DropdownContainer,
	DropdownButton,
	DropdownMenu,
} from "../styles/Dropdown.styles.js";
import DropdownIcon from "./DropdownIcon.jsx";

const NavDropdown = ({ title, children, className, style }) => {
	const [isOpen, setIsOpen] = useState(false);
	const dropdownRef = useRef(null);

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
				setIsOpen(false);
			}
		};

		const handleEscape = (event) => {
			if (event.key === "Escape") {
				setIsOpen(false);
			}
		};

		if (isOpen) {
			document.addEventListener("mousedown", handleClickOutside);
			document.addEventListener("keydown", handleEscape);
		}

		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
			document.removeEventListener("keydown", handleEscape);
		};
	}, [isOpen]);

	const handleToggle = () => {
		setIsOpen(!isOpen);
	};

	const handleKeyDown = (event) => {
		if (event.key === "Enter" || event.key === " ") {
			event.preventDefault();
			handleToggle();
		}
	};

	return (
		<DropdownContainer
			ref={dropdownRef}
			className={className}
			style={style}
			isOpen={isOpen}
		>
			<DropdownButton
				onClick={handleToggle}
				onKeyDown={handleKeyDown}
				aria-expanded={isOpen}
				aria-haspopup="true"
				aria-controls={`dropdown-menu-${title}`}
				tabIndex={0}
				open={isOpen}
				type="button"
			>
				{title}
				<DropdownIcon isOpen={isOpen} />
			</DropdownButton>

			<DropdownMenu
				open={isOpen}
				role="menu"
				id={`dropdown-menu-${title}`}
				aria-labelledby={`dropdown-button-${title}`}
			>
				{children}
			</DropdownMenu>
		</DropdownContainer>
	);
};

export default NavDropdown;
